import React, { useState, useCallback, useEffect } from "react";
import ForumTopics from "./ForumTopics/ForumTopics";
import classes from "./ForumArea.module.scss";
import ForumThreads from "./ForumThreads/ForumThreads";
import AddIcon from "../../../components/Common/SvgIcons/AddIcon";
import Modal from "../../../components/Common/Modal/Modal";
import CreateForumTopic from "./ForumTopics/CreateForumTopic/CreateForumTopic";
import { useDispatch, useSelector } from "react-redux";
import {
  getForumCommentsActionHandler,
  getPollUserGroupsHandler,
} from "../../../store/actions/actionHandlers/socialActionHandler";
import { setCreateForumTopicResponse } from "../../../store/actions/actionCreators/socialActionCreator";
import { mode } from "../../../utils/formModes";
import ChatContainer from "./ChatContainer/ChatContainer";
import ForumComments from "./ForumComments/ForumComments";
import { FormattedMessage } from "react-intl";

const ForumArea = () => {
  const pageSize = 10;
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [selectedForumTopicData, setselectedForumTopicData] = useState(null);
  const [createForumTopicModal, setCreateForumTopicModal] = useState(false);
  const [selectedTopicObj, setSelectedTopicObj] = useState(null);
  const [formMode, setFormMode] = useState(mode.ADD);
  const [forumComments, setForumComments] = useState(null);
  const [forumCommentsPageNum, setForumCommentsPageNum] = useState(1);
  const [selectedThread, setSelectedThread] = useState(null);
  const [forumCommentsTotalRows, setForumCommentsTotalRows] = useState(0);
  const [forumCommentLoader, setForumCommentLoader] = useState(false);

  const handleForumClick = useCallback((topic) => {
    setselectedForumTopicData(topic);
    setForumComments(null);
    setForumCommentsPageNum(1);
  }, []);

  // useEffect(() => {
  //   dispatch(getPollUserGroupsHandler());
  // }, [dispatch]);

  const selectedTopic = (topic) => {
    setSelectedTopicObj(topic);
    setFormMode(mode.EDIT);
  };

  const forwardLinkIconClick = (thread) => {
    setSelectedThread(thread);
    dispatch(
      getForumCommentsActionHandler(
        thread?.Id,
        forumCommentsPageNum,
        pageSize,
        setForumComments,
        setForumCommentsTotalRows,
        setForumCommentLoader
      )
    );
  };
  return (
    <>
      <div className={classes.forumAreaMain}>
        <div className={classes.addNewTopic}>
          <span
            className={classes.addIcon}
            onClick={() => {
              setCreateForumTopicModal(true);
              dispatch(setCreateForumTopicResponse(null));
              setFormMode(mode.ADD);
            }}
          >
            <AddIcon fill={colors.theme} />
          </span>
          <p
            className={classes.text}
            onClick={() => {
              setCreateForumTopicModal(true);
              dispatch(setCreateForumTopicResponse(null));
              setFormMode(mode.ADD);
            }}
          >
            <FormattedMessage id="FORUM_ADD_NEW_TOPIC" />
          </p>
        </div>
        <ChatContainer
          leftArea={
            <ForumTopics
              handleForumClick={handleForumClick}
              setCreateForumTopicModal={setCreateForumTopicModal}
              selectedTopic={selectedTopic}
              setSelectedThread={setSelectedThread}
            />
          }
          rightArea={
            selectedThread ? (
              <ForumComments
                forumComments={forumComments}
                setForumComments={setForumComments}
                setForumCommentsPageNum={setForumCommentsPageNum}
                selectedThread={selectedThread}
                forumCommentsTotalRows={forumCommentsTotalRows}
                forumCommentsPageNum={forumCommentsPageNum}
                pageSize={pageSize}
                setForumCommentsTotalRows={setForumCommentsTotalRows}
                setSelectedThread={setSelectedThread}
                forumCommentLoader={forumCommentLoader}
              />
            ) : (
              <ForumThreads
                selectedForumTopicData={selectedForumTopicData}
                setselectedForumTopicData={setselectedForumTopicData}
                forwardLinkIconClick={forwardLinkIconClick}
              />
            )
          }
        />
      </div>

      <Modal
        isOpen={createForumTopicModal}
        heading={
          formMode === mode.ADD ? (
            <FormattedMessage id="FORUM_ADD_NEW_TOPIC" />
          ) : (
            <FormattedMessage id="EDIT_TOPIC" />
          )
        }
        toggle={() => {
          setCreateForumTopicModal(false);
        }}
        width={"45"}
      >
        <CreateForumTopic
          setCreateForumTopicModal={setCreateForumTopicModal}
          selectedTopic={selectedTopicObj}
          formMode={formMode}
        />
      </Modal>
    </>
  );
};

export default ForumArea;
